import { useEffect, useState, type ReactNode } from "react";
import { supabase } from "@/integrations/supabase/client";

type State = "loading" | "anon" | "member";

/**
 * Route entry for /community. Signed-in users get the member app; signed-out
 * visitors get the public landing page instead of a bare login wall.
 */
export function CommunityEntry({ member, landing }: { member: ReactNode; landing: ReactNode }) {
  const [state, setState] = useState<State>("loading");

  useEffect(() => {
    let mounted = true;
    supabase.auth.getUser().then(({ data }) => {
      if (mounted) setState(data.user ? "member" : "anon");
    });
    return () => {
      mounted = false;
    };
  }, []);

  if (state === "loading") return null;
  return <>{state === "member" ? member : landing}</>;
}
